import { Section, Eyebrow, H1, FadeIn } from "../components/Primitives";

const sections = [
  {
    title: "Information we collect",
    body: "We collect only the information you provide while signing up, contacting us, or using Register to Digital — your name, email, phone number, organisation, and the registers you choose to digitize. We do not collect data we do not need."
  },
  {
    title: "How we use your data",
    body: "Your data is used solely to provide and improve Register to Digital. We never sell your data, never share it with advertisers, and never use customer data to train our OCR models without explicit consent."
  },
  {
    title: "Where your data lives",
    body: "All customer data is stored on encrypted servers physically located in India. Data is encrypted at rest (AES-256) and in transit (TLS 1.3). You can export or delete your data at any time."
  },
  {
    title: "GDPR & DPDP compliance",
    body: "We comply with the Digital Personal Data Protection Act (DPDP), 2023 (India) and the EU GDPR for our international customers. You have the right to access, correct, export and delete your data."
  },
  {
    title: "Cookies",
    body: "We use minimal cookies, only for keeping you signed in and remembering your preferences. We do not use third-party advertising cookies."
  },
  {
    title: "Children's privacy",
    body: "Register to Digital is intended for businesses and institutions. We do not knowingly collect data from individuals under 18."
  },
  {
    title: "Contact us",
    body: "Questions about your privacy? Email info@registertodigital.com and we'll respond within one business day."
  },
];

export default function PrivacyPage() {
  return (
    <div data-testid="page-privacy">
      <Section className="pt-24 pb-12">
        <FadeIn><Eyebrow>Legal</Eyebrow></FadeIn>
        <FadeIn delay={0.05}><H1 className="mt-6 max-w-3xl">Privacy Policy</H1></FadeIn>
        <FadeIn delay={0.1}>
          <p className="mt-5 text-sm text-zinc-500">Last updated: December 2, 2025</p>
        </FadeIn>
      </Section>

      <Section className="pt-0">
        <div className="mx-auto max-w-3xl space-y-10">
          {sections.map((s, i) => (
            <div key={s.title} data-testid={`privacy-section-${i}`}>
              <h2 className="font-poppins text-xl font-semibold text-zinc-950">{s.title}</h2>
              <p className="mt-3 text-base leading-relaxed text-zinc-600">{s.body}</p>
            </div>
          ))}
        </div>
      </Section>
    </div>
  );
}
